
import Vue from 'vue'
import { SismoazurEventParameter } from '@/types'

export default Vue.extend({
  props: {
    event: {
      type: Object as () => SismoazurEventParameter,
      default: null
    }
  },
  data () {
    return {
      isReady: false,
      waveforms: [],
      fallback: false,
      resmeca: ''
    }
  },
  mounted () {
    this.run()
  },
  watch: {
    event: function (value: SismoazurEventParameter) {
      this.run()
    }
  },
  methods: {
    run () {
      this.isReady = false
      this.waveforms = []
      this.fallback = false
      this.resmeca = ''
      if (this.event != null && this.event._fm != null) {
        this.detectResultVersion()
      }
    },
    detectResultVersion () {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', `resource/file?name=mwfm/result_complete.jpg&eventid=${this.event.public_id}`)
      xhr.onload = () => {
        if (xhr.status === 200) {
          this.isReady = true
        } else {
          this.loadFallback()
        }
      }
      xhr.onerror = () => {
        this.loadFallback()
      }
      xhr.send()
    },
    loadWaveforms (callback: Function) {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', `resource/list_fm_waveform?eventid=${this.event.public_id}`)
      xhr.responseType = 'json'
      xhr.onload = () => {
        this.waveforms = xhr.response
        callback()
      }
      xhr.send()
    },
    loadResmeca (callback: Function) {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', `resource/file?name=mwfm/resmeca&eventid=${this.event.public_id}`)
      xhr.responseType = 'text'
      xhr.onload = () => {
        this.resmeca = xhr.response
        callback()
      }
      xhr.send()
    },
    loadFallback () {
      this.fallback = true
      this.loadResmeca(() => {
        this.loadWaveforms(() => {
          this.isReady = true
        })
      })
    }
  }
})
